/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-empty-function */
import React, { FC, memo, useEffect, useRef } from 'react';

interface ISecurityResponse {
  result: {
    risk_token: string;
  };
}

export interface ISecurityData {
  username?: string; // 邮箱｜手机号
  country_code?: string; // 手机区号
}

interface IProps {
  loginData?: {
    username?: string; // 邮箱｜手机号
    country_code?: string; // 手机区号
  };

  risk_token: string | undefined; // riskToken
  clearTokenHandler: (val?: string | undefined) => void; // 取消时，需要将riskToken重置，
  callBack: (
    riskToken?: ISecurityResponse,
    verify?: { google2fa?: string },
  ) => void; // 操作成功|确定时，回调函数
  faceFailHandler?: () => void; // 人脸三次失败，业务根据自己的特点进行接入
  showCallback?: () => void;
  closeCallbackAfterSuccess?: boolean;
}

const BySecurity: FC<IProps> = ({
  clearTokenHandler,
  risk_token,
  loginData,
  callBack,
  faceFailHandler,
  showCallback,
  closeCallbackAfterSuccess = true,
}) => {
  const riskTokenPass = (res: ISecurityResponse, verifyCode: any) => {
    callBack(res, verifyCode);
    if (closeCallbackAfterSuccess) {
      clearTokenHandler(undefined);
    }
  };

  useEffect(() => {
    let resetHandler = () => {};
    let securityInstance: any;

    const faceFailOrClose = (res: any) => {
      console.info(res, ' ---- res ----');
      if (res) {
        // 自行关闭
        resetHandler();
      } else if (faceFailHandler) {
        // 3波验证都失败（9次）
        faceFailHandler && faceFailHandler();
      } else {
        // 兜底逻辑关闭, 可以不用配置人脸验证失败，默认走关闭逻辑
        resetHandler();
      }
    };

    // 与react编写交互时，注意react的fiber生命周期与window不一样
    window.BybitUniFrame?.ready(({ security }: any) => {
      securityInstance = security;
      const {
        USE_NEW_SECURITY_VERIFICATION_NOT_AVAILABLE,
        VISIBLE,
        USER,
        RISK_TOKEN,
      } = security.properties;

      security.setProperty(USE_NEW_SECURITY_VERIFICATION_NOT_AVAILABLE, true);

      const { SAVE_HANDLER, CANCEL_HANDLER, CLOSE_MODAL_HANDLER, ON_KYC_FAIL } =
        security.events;

      // 安全项配置重置
      resetHandler = () => {
        security.setProperty(USER, { username: '' });
        security.setProperty(RISK_TOKEN, null);
        security.setProperty(VISIBLE, false);
        security.unsubscribeEvent(SAVE_HANDLER, riskTokenPass);
        clearTokenHandler(undefined);
      };

      security.setProperty(USER, {
        username: '',
        country_code: '',
        ...loginData,
      });
      security
        .subscribeEvent(CLOSE_MODAL_HANDLER, resetHandler)
        .subscribeEvent(CANCEL_HANDLER, resetHandler);
      security.subscribeEvent(ON_KYC_FAIL, faceFailOrClose);
      security.setProperty(RISK_TOKEN, risk_token);
      security.setProperty(VISIBLE, true);
      security.subscribeEvent(SAVE_HANDLER, riskTokenPass);
      showCallback?.();
    });
    return () => {
      if (securityInstance) {
        const {
          CANCEL_HANDLER,
          SAVE_HANDLER,
          CLOSE_MODAL_HANDLER,
          ON_KYC_FAIL,
        } = securityInstance.events;
        const { VISIBLE } = securityInstance.properties;
        securityInstance.setProperty(VISIBLE, false);
        securityInstance
          .unsubscribeEvent(CLOSE_MODAL_HANDLER, resetHandler)
          .unsubscribeEvent(CANCEL_HANDLER, resetHandler)
          .unsubscribeEvent(ON_KYC_FAIL, faceFailOrClose)
          .unsubscribeEvent(SAVE_HANDLER, riskTokenPass);

        securityInstance.dealloc();
      }
    };
  }, []);

  return <></>;
};

export default memo(BySecurity, (prepProps, currentProps) => {
  return prepProps.risk_token === currentProps.risk_token;
});
